module.exports = __webpack_public_path__ + "img/08.de6f2d1c.svg";